import { DeliveryPerformanceAnalyticsActionTypes } from './constants';

export const INIT_STATE = {
    errorGetOnTimeShipments: null,
    loadingOnTimeShipments: false,
    onTimeShipments: null,
    errorGetLateShipments: null,
    loadingLateShipments: false,
    lateShipments: null,
    errorGetEarlyShipments: null,
    loadingEarlyShipments: false,
    earlyShipments: null,
    errorGetDeliveryPerformance: null,
    loadingDeliveryPerformance: false,
    deliveryPerformance: null,
    errorGetDeliveryPerformanceByTimeframe: null,
    loadingDeliveryPerformanceByTimeframe: false,
    deliveryPerformanceByTimeframe: null,
};

type DeliveryPerformanceAnalyticsAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};

type State = {
    errorGetOnTimeShipments?: null,
    loadingOnTimeShipments: Boolean,
    onTimeShipments: any,
    errorGetLateShipments?: null,
    loadingLateShipments: Boolean,
    lateShipments: any,
    errorGetEarlyShipments?: null,
    loadingEarlyShipments: Boolean,
    earlyShipments: any,
    errorGetDeliveryPerformance?: null,
    loadingDeliveryPerformance: Boolean,
    deliveryPerformance: any,
    errorGetDeliveryPerformanceByTimeframe?: null,
    loadingDeliveryPerformanceByTimeframe: Boolean,
    deliveryPerformanceByTimeframe: any,
};

const DeliveryPerformanceAnalytics = (state: State = INIT_STATE, action: DeliveryPerformanceAnalyticsAction): any => {
    switch (action.type) {
        case DeliveryPerformanceAnalyticsActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case DeliveryPerformanceAnalyticsActionTypes.GET_ON_TIME_SHIPMENTS: {
                    return { ...state, loadingOnTimeShipments: false, onTimeShipments: action.payload.data };
                }
                case DeliveryPerformanceAnalyticsActionTypes.GET_LATE_SHIPMENTS: {
                    return { ...state, loadingLateShipments: false, lateShipments: action.payload.data };
                }
                case DeliveryPerformanceAnalyticsActionTypes.GET_EARLY_SHIPMENTS: {
                    return { ...state, loadingEarlyShipments: false, earlyShipments: action.payload.data };
                }
                case DeliveryPerformanceAnalyticsActionTypes.GET_DELIVERY_PERFORMANCE: {
                    return { ...state, loadingDeliveryPerformance: false, deliveryPerformance: action.payload.data };
                }
                case DeliveryPerformanceAnalyticsActionTypes.GET_DELIVERY_PERFORMANCE_BY_TIMEFRAME: {
                    return { ...state, loadingDeliveryPerformanceByTimeframe: false, deliveryPerformanceByTimeframe: action.payload.data };
                }
                default:
                    return { ...state, loadingOnTimeShipments: false, loadingLateShipments: false, loadingEarlyShipments: false, loadingDeliveryPerformance: false, loadingDeliveryPerformanceByTimeframe: false };
            }

        case DeliveryPerformanceAnalyticsActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case DeliveryPerformanceAnalyticsActionTypes.GET_ON_TIME_SHIPMENTS: {
                    return { ...state, loadingOnTimeShipments: false, errorGetOnTimeShipments: action.payload.error };
                }
                case DeliveryPerformanceAnalyticsActionTypes.GET_LATE_SHIPMENTS: {
                    return { ...state, loadingLateShipments: false, errorGetLateShipments: action.payload.error };
                }
                case DeliveryPerformanceAnalyticsActionTypes.GET_EARLY_SHIPMENTS: {
                    return { ...state, loadingEarlyShipments: false, errorGetEarlyShipments: action.payload.error };
                }
                case DeliveryPerformanceAnalyticsActionTypes.GET_DELIVERY_PERFORMANCE: {
                    return { ...state, loadingDeliveryPerformance: false, errorGetDeliveryPerformance: action.payload.error };
                }
                case DeliveryPerformanceAnalyticsActionTypes.GET_DELIVERY_PERFORMANCE_BY_TIMEFRAME: {
                    return { ...state, loadingDeliveryPerformanceByTimeframe: false, errorGetDeliveryPerformanceByTimeframe: action.payload.error };
                }
                default:
                    return { ...state };
            }

        case DeliveryPerformanceAnalyticsActionTypes.GET_ON_TIME_SHIPMENTS:
            return { ...state, loadingOnTimeShipments: true, onTimeShipments: null };
        case DeliveryPerformanceAnalyticsActionTypes.GET_LATE_SHIPMENTS:
            return { ...state, loadingLateShipments: true, lateShipments: null };
        case DeliveryPerformanceAnalyticsActionTypes.GET_EARLY_SHIPMENTS:
            return { ...state, loadingEarlyShipments: true, earlyShipments: null };
        case DeliveryPerformanceAnalyticsActionTypes.GET_DELIVERY_PERFORMANCE:
            return { ...state, loadingDeliveryPerformance: true, deliveryPerformance: null };
        case DeliveryPerformanceAnalyticsActionTypes.GET_DELIVERY_PERFORMANCE_BY_TIMEFRAME:
            return { ...state, loadingDeliveryPerformanceByTimeframe: true, deliveryPerformanceByTimeframe: null };
        default:
            return { ...state };
    }
};

export default DeliveryPerformanceAnalytics;
